import { memo } from 'react';
import cn from 'classnames';
import styles from '../plansPage.module.scss';

const ReviewBanner = () => {
  const bannerStyles = cn('paddingY-tiny marginBottom-large1', styles.bannerContainer);
  return (
    <div className={bannerStyles}>
      <div className={styles.bannerItem}>
        <p className="h5 white">“The best tech support.” by USA Today</p>
      </div>
    </div>
  );
};

export default memo(ReviewBanner);
